import * as Types from '../../types';

import { gql } from '@apollo/client';
import { EntityDisplayFragmentDoc } from '../EntityDisplay/EntityDisplay.generated';
import { AddressRiskIndicatorFragmentDoc } from '../RiskIndicator/RiskIndicator.generated';
export type AddressDisplayFragment = {
  __typename?: 'Address';
  address: string;
  entity?: {
    __typename?: 'Entity';
    id: any;
    name: string;
    risks: {
      __typename?: 'EntityRiskConnection';
      totalCount: number;
      pageInfo: {
        __typename?: 'PageInfo';
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
        endCursor?: string | null;
      };
      edges: Array<{
        __typename?: 'EntityRiskEdge';
        node: {
          __typename?: 'EntityRisk';
          id: any;
          riskType: string;
          severity: string;
          description?: string | null;
        };
      }>;
    };
  } | null;
  risks: {
    __typename?: 'AddressRiskConnection';
    totalCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
    edges: Array<{
      __typename?: 'AddressRiskEdge';
      node: {
        __typename?: 'AddressRisk';
        id: any;
        riskType: string;
        severity: string;
        description?: string | null;
      };
    }>;
  };
};

export const AddressDisplayFragmentDoc = gql`
  fragment AddressDisplay on Address {
    address
    entity {
      ...EntityDisplay
    }
    risks {
      ...AddressRiskIndicator
    }
  }
  ${EntityDisplayFragmentDoc}
  ${AddressRiskIndicatorFragmentDoc}
`;
